import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ApiKey, compressBase64Image, fetchLocation } from './utils/UtilityFunctions';
import MainLoader from './components/MainLoader';
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  FormControlLabel,
  Tabs,
  Tab,
  InputAdornment,
  OutlinedInput
} from "@mui/material";
import { useNavigate } from 'react-router';
import i18next from 'i18next';
import Sidebar from './components/Sidebar';
import debounce from "lodash.debounce";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import jsPDF from "jspdf";
import { toPng } from "html-to-image";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { QRCodeSVG, QRCodeCanvas } from "qrcode.react";
import imgurl from './assests/images/imgurl';
import html2canvas from 'html2canvas'

const GenerateQr = () => {

  const navigate = useNavigate()
  const formRef = useRef()
  const qrEngRef = useRef(null);
  const qrEspRef = useRef(null);
  const qrFrRef = useRef(null);
  const qrRef = useRef();
  const autocompleteRef = useRef(null);
  const [activeLanguageTab, setActiveLanguageTab] = useState("home"); 
  const [generateQRCode, setGenerateQRCode] = useState(false);
  const [generateDummyQR, setGenerateDummyQR] = useState(false);
  const [formValues, setFormValues] = useState({
    partner_name: "",
    partner_phone_no: "",
    partner_type: "",
    email: "",
    address: "",
    gps_lat: "",
    gps_lng: "",
    message_top_english: "Losing Hair?",
    message_bottom_english: "Scan now for your free Al scalp analysis on WhatsApp",
    message_top_spanish: "¿Perdes el pelo?",
    message_bottom_spanish: "Escanea el cuero cabelludo con IA gratis en WhatsApp",
    message_top_french: "Perte de cheveux ?",
    message_bottom_french: "Scannez maintenant pour obtenir votre analyse de scalp Al gratuite sur WhatsApp",
    whatsapp_msg_english: "Hello, I would like to know more about Alopexia.",
    whatsapp_msg_spanish: "Hola, me gustaría saber más sobre Alopexia.",
    whatsapp_msg_french: "Bonjour, j'aimerais en savoir plus sur Alopexia.",
  });
  const [countryCode, setCountryCode] = useState('')
  const [QREng, setQREng] = useState('')
  const [QREsp, setQREsp] = useState('')
  const [QRFr, setQRFr] = useState('')
  const [QRLinkEng, setQRLinkEng] = useState('')
  const [QRLinkEsp, setQRLinkEsp] = useState('')
  const [QRLinkFr, setQRLinkFr] = useState('')
  const [copySuccess, setCopySuccess] = useState('')
  const [mapCenter, setMapCenter] = useState({
    lat: 40.416775,
    lng: -3.703790,
  });
  const [zoom, setZoom] = useState(12);
  const [addressFound, setAddressFound] = useState(true);
  const [refCode, setRefCode] = useState('')
  const [isLoading, setIsLoading] = useState('')
  const [validated, setValidated] = useState(false);
  const options = useMemo(
    () => ({
      mapTypeControl: false,
      streetViewControl: false,
      zoomControl: false,
      fullscreenControl: false,
    }),
    []
  );

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: ApiKey, // Replace with your Google Maps API Key
    libraries: ["places"], // Needed for Autocomplete
  });

  const formQuestions = [
    {
      title: "Business Name",
      type: "text",
      placeholder: "Enter partner name",
      commonIdentifier: "p_name",
    },
    {
      title: "Business Contact",
      type: "number",
      placeholder: "Enter contact number",
      commonIdentifier: "p_num",
    },
    {
      title: "Business Type",
      type: "dropdown",
      placeholder: "Enter owner name",
      commonIdentifier: "o_name",
      optionMap: [
        "Beauty Salon",
        "Hairdresser",
        "Hotel",
        "Cruise Ship",
        "Individual",
        "Restaurant",
        "Gym/Fitness Center",
        "Spa",
        "Coffee Shop",
        "Others",
      ],
    },
    {
      title: "Email",
      type: "email",
      placeholder: "Enter your email",
      commonIdentifier: "email",
    },
    {
      title: "Address",
      type: "location",
      placeholder: "Enter location",
      commonIdentifier: "address",
    },
    { title: "Language", type: "language" },
  ];

  useEffect(() => {
    if (!qrEngRef.current || !qrEspRef.current || !qrFrRef.current) return;
  
    Promise.all([
      html2canvas(qrEngRef.current, {scale: 2}),
      html2canvas(qrEspRef.current, {scale: 2}),
      html2canvas(qrFrRef.current, {scale: 2}),
    ]).then(([canvasEng, canvasEsp, canvasFr]) => {
      setQREng(canvasEng.toDataURL("image/png").split(",")[1]);
      setQREsp(canvasEsp.toDataURL("image/png").split(",")[1]);
      setQRFr(canvasFr.toDataURL("image/png").split(",")[1]);
    });
  }, [generateQRCode]);

  useEffect(() => {
    currentLocation()
  }, [])

  const currentLocation = async () => {               // get current geolocation
    try {
      let coordinates = await fetchLocation()
      console.log("coordinates", coordinates);
      setMapCenter({
        lat: coordinates[0],
        lng: coordinates[1]
      })
    } catch(err) {
      console.log("err", err);
    }
  }

  const generatePDF = async () => {
    if (!qrRef.current) return;
    console.log("activeLanguage", activeLanguageTab);
    setIsLoading(true)
    // Clone original DOM
    const originalNode = qrRef.current;
    const clonedNode = originalNode.cloneNode(true);

    // Style wrapper to hold both side by side (with gap between them)
    const wrapper = document.createElement("div");
    wrapper.style.display = "flex";
    wrapper.style.justifyContent = "center";
    wrapper.style.gap = "5px"; // Add a gap of 20px between the two DOM elements (white space)
    wrapper.style.padding = "0"; // No padding
    // wrapper.style.margin = "10"; // No margin
    wrapper.style.backgroundColor = "#fff";
    wrapper.style.boxSizing = "border-box"; // Ensure padding and margin don't interfere

    wrapper.appendChild(originalNode.cloneNode(true));
    wrapper.appendChild(clonedNode);

    document.body.appendChild(wrapper);

    try {
      const dataUrl = await toPng(wrapper, { pixelRatio: 2 });

      const pdf = new jsPDF("landscape", "mm", "a4");
      const img = new Image();
      img.src = dataUrl;

      img.onload = () => {
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Scale image to fit full width (or adjust if needed)
        const targetWidth = pdfWidth; // Set to full width
        const targetHeight = (img.height * targetWidth) / img.width;

        // Add extra height to the image if needed (e.g., use the remaining white space)
        const extraHeight = 0; // Adjust this value to add more height
        const adjustedHeight = targetHeight + extraHeight; // Add extra space

        // Calculate offsets to leave white space
        const xOffset = (pdfWidth - targetWidth) / 2;
        const yOffset = (pdfHeight - adjustedHeight) / 2; // Center image, but leave extra white space

        // Add the image to the PDF with adjusted height and white space
        pdf.setFillColor(17, 62, 102); // or use hex: pdf.setFillColor("#113E66")
        pdf.rect(0, 0, pdfWidth, pdfHeight, "F"); // Fill entire PDF page
        pdf.addImage(img, "PNG", xOffset, yOffset, targetWidth, adjustedHeight);
        pdf.save(activeLanguageTab == 'home' ? "AloxaQR-Eng.pdf" : activeLanguageTab == 'link-1' ? "AloxaQR-Esp.pdf" : activeLanguageTab == 'link-2' ? "AloxaQR-Fr.pdf" : 'AloxaQR.pdf');

        // Clean up
        document.body.removeChild(wrapper);
        setIsLoading(false)
      };
    } catch (err) {
      console.error("Error generating image:", err);
      document.body.removeChild(wrapper);
    }
  };

  const getQuestionType = (element) => {
    switch (element.type) {
      case "text":
        return getTextType(element);
      case "number":
        return getNumberType(element);
      case "email":
        return getEmailType(element);
      case "dropdown":
        return getDropdownType(element);
      case "location":
        return getLocationType(element);
      case "language":
        return getLanguageTab(element);
      default:
        return getTextType(element);
    }
  };

  const getTextType = (element) => {
    return (
      <FormControl fullWidth margin="normal">
        <TextField
          required
          type="text"
          label={element.title}
          // placeholder={element?.placeholder || ""}
          inputProps={{ maxLength: 30 }}
           InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {/* <LockIcon /> */}
                                    </InputAdornment>
                                  ),
                                }}
          onChange={(e) =>
            handleFormValues(e.target.value, element?.commonIdentifier)
          }
          className='commonInputText'
        />
      </FormControl>
    );
  };

  const getNumberType = (element) => {
    const countryCodes = [
      { title: 'Spain (+34)', value: 'Spain', code: '+34' },
      { title: 'France (+33)', value: 'France', code: '+33' },
      { title: 'UK (+44)', value: 'UK', code: '+44' },
      { title: 'India (+91)', value: 'India', code: '+91' },
    ];

    return (
      <FormControl fullWidth margin="normal">
        {/* <InputLabel>{element.title}</InputLabel> */}
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <InputLabel id="country-code-label">Country code</InputLabel>
  <Select
    labelId="country-code-label"
    id="country-code-select"
    defaultValue=""
    displayEmpty
    label="Country code"
    className='commonSelectText'
    onChange={(e) => handleFormValues(e.target.value, "country-code")}
    input={
      <OutlinedInput
        startAdornment={
          <InputAdornment position="start">
            {/* Optional icon here */}
          </InputAdornment>
        }
      />
    }
    MenuProps={{
        PaperProps: {
          className: 'custom-menu-paper',
        },
      }}
  >
    {/* This item acts as a placeholder when value is "" */}
    <MenuItem value="" disabled>
      Country code
    </MenuItem>
    {countryCodes.map((c, index) => (
      <MenuItem key={index} value={c.value}>
        {c.title}
      </MenuItem>
    ))}
  </Select>
          </Grid>
          <Grid item xs={7}>
            <TextField
              required
              fullWidth
              type="text"
              inputMode="numeric"
              label={element.title}
              // placeholder={element?.placeholder || ""}
              inputProps={{ maxLength: 10 }}
              onChange={(e) => {
                const rawValue = e.target.value;
                const cleanedValue = rawValue.replace(/\D/g, '').slice(0, 10);
                handleFormValues(cleanedValue, element?.commonIdentifier);
              }}
              InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {/* <LockIcon /> */}
                                    </InputAdornment>
                                  ),
                                }}
               className='commonInputText'
            />
          </Grid>
        </Grid>
      </FormControl>
    );
  };

  const getEmailType = (element) => {
    return (
      <FormControl fullWidth margin="normal">
        <TextField
          required
          type="email"
          label={element.title}
          // placeholder={element?.placeholder || ""}
          inputProps={{
            pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
          }}
          onChange={(e) =>
            handleFormValues(e.target.value, element?.commonIdentifier)
          }
          InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {/* <LockIcon /> */}
                                    </InputAdornment>
                                  ),
                                }}
           className='commonInputText'
        />
      </FormControl>
    );
  };

  const getDropdownType = (element) => {
    return (
      <FormControl fullWidth margin="normal">
        <InputLabel>{element.title}</InputLabel>
        <Select
          required
          defaultValue=""
          label=""
          onChange={(e) => handleFormValues(e.target.value, element?.commonIdentifier)}
          className='commonSelectText'
          input={
      <OutlinedInput
        startAdornment={
          <InputAdornment position="start">
            {/* Optional icon here */}
          </InputAdornment>
        }
      />
    }
        >
          <MenuItem value="">Please select</MenuItem>
          {element.optionMap.map((o, index) => (
            <MenuItem key={index} value={o}>
              {o}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const getLocationType = (element) => {
    return (
      <FormControl fullWidth margin="normal" className='mt-10px'>
        <div className="addressContainer">
          <FormControlLabel
          label={addressFound ? element.title : "No Address Found"}
          labelPlacement="start"
            control={
              <Switch
                checked={addressFound}
                onChange={(e) => setAddressFound(e.target.checked)}
              />
            }
            
          />
        </div>

        {addressFound && isLoaded && mapCenter ? (
          <>
            <div className="googlePlaceDiv">
              <GooglePlacesAutocomplete
                className="googlePlaceTxtbox commonInputText mb-20px"
                apiKey={ApiKey}
                label={element.title}
                onPlaceSelected={handlePlaceSelected}
                ref={autocompleteRef}
                options={{ types: ["establishment"] }}
                placeholder="Enter a location"
                style={{
                  width: "100%",
                  height: "40px",
                  padding: "10px",
                  fontSize: "16px",
                }}
                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {/* <LockIcon /> */}
                                    </InputAdornment>
                                  ),
                                }}
              />
            </div>
            <GoogleMap
              mapContainerStyle={{ width: "100%", height: "60vh" }}
              center={mapCenter}
              zoom={zoom}
              options={options}
            >
              <MarkerF
                position={mapCenter}
                draggable
                onDrag={handleMarkerDragEnd}
              />
            </GoogleMap>
          </>
        ) : (
          <TextField
            required
            fullWidth
             label={element.title}
            // placeholder="Enter manual address"
            className='commonInputText'
             InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {/* <LockIcon /> */}
                                    </InputAdornment>
                                  ),
                                }}
            onChange={(e) => handleFormValues(e.target.value, "address")}
          />
        )}
      </FormControl>
    );
  };

  const handleFormValues = (value, identifier) => {
    if(identifier == "country-code"){
      let countryCodes = [
        {title: 'Spain (+34)', value: 'Spain', code: '34'},
        {title: 'France (+33)', value: 'France', code: '33'},
        {title: 'UK (+44)', value: 'UK', code: '44'},
        {title: 'India (+91)', value: 'India', code: '91'},
      ]
      countryCodes.map((c) => {
        if(c.value === value){
          setCountryCode(c.code)
        }
      })
    } else {
      setFormValues((prev) => {
        const updated = { ...prev };
  
        switch (identifier) {
          case "p_name":
            // Allow only alphabets and spaces for name
            if (/^[a-zA-Z\s]*$/.test(value)) {
              updated.partner_name = value;
            }
            break;
          case "p_num":
            // Allow only numbers and ensure it's 10 digits
            if (/^\d{10}$/.test(value)) {
              updated.partner_phone_no = value;
            }
            break;
          case "email":
            // Simple email validation
            if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
              updated.email = value;
            }
            break;
          case "p_type":
            updated.partner_type = value;
            break;
          case "address":
            updated.address = value;
            break;
          case "eng_top":
            updated.message_top_english = value;
            break;
          case "eng_bottom":
            updated.message_bottom_english = value;
            break;
          case "esp_top":
            updated.message_top_spanish = value;
            break;
          case "esp_bottom":
            updated.message_bottom_spanish = value;
            break;
          case "fr_top":
            updated.message_top_french = value;
            break;
          case "fr_bottom":
            updated.message_bottom_french = value;
            break;
          case "whatsapp_eng":
            updated.whatsapp_msg_english = value;
            break;
          case "whatsapp_esp":
            updated.whatsapp_msg_spanish = value;
            break;
          case "whatsapp_fr":
            updated.whatsapp_msg_french = value;
            break;
          default:
            break;
        }
  
        return updated;
      });
    }
  };

  const getLanguageTab = (element) => {
    const renderContent = () => {
      switch (activeLanguageTab) {
        case "home":
          return (
            <>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Message on Top"
                  inputProps={{ maxLength: 30 }}
                  placeholder="Enter your message"
                  value={formValues.message_top_english}
                  onChange={(e) =>
                    handleFormValues(e.target.value, "eng_top")
                  }
                />
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Message in Bottom"
                  inputProps={{ maxLength: 100 }}
                  placeholder="Enter your message"
                  value={formValues.message_bottom_english}
                  onChange={(e) =>
                    handleFormValues(e.target.value, "eng_bottom")
                  }
                />
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="WhatsApp Onboarding Message"
                  inputProps={{ maxLength: 150 }}
                  placeholder="Enter your message"
                  value={formValues.whatsapp_msg_english}
                  onChange={(e) =>
                    handleFormValues(e.target.value, "whatsapp_eng")
                  }
                />
              </Box>
            </>
          );

        case "link-1":
          return (
            <>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Mensaje en la parte superior"
                  inputProps={{ maxLength: 30 }}
                  placeholder="Enter your message"
                  value={formValues.message_top_spanish}
                  onChange={(e) =>
                    handleFormValues(e.target.value, "esp_top")
                  }
                />
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Mensaje en la parte inferior"
                  inputProps={{ maxLength: 100 }}
                  placeholder="Enter your message"
                  value={formValues.message_bottom_spanish}
                  onChange={(e) =>
                    handleFormValues(e.target.value, "esp_bottom")
                  }
                />
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Mensaje de incorporación de WhatsApp"
                  inputProps={{ maxLength: 150 }}
                  placeholder="Enter your message"
                  value={formValues.whatsapp_msg_spanish}
                  onChange={(e) =>
                    handleFormValues(e.target.value, "whatsapp_esp")
                  }
                />
              </Box>
            </>
          );

        case "link-2":
          return (
            <>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Message en haut"
                  inputProps={{ maxLength: 30 }}
                  placeholder="Enter your message"
                  value={formValues.message_top_french}
                  onChange={(e) =>
                    handleFormValues(e.target.value, "fr_top")
                  }
                />
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Message en bas"
                  inputProps={{ maxLength: 100 }}
                  placeholder="Enter your message"
                  value={formValues.message_bottom_french}
                  onChange={(e) =>
                    handleFormValues(e.target.value, "fr_bottom")
                  }
                />
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Message d'intégration WhatsApp"
                  inputProps={{ maxLength: 150 }}
                  placeholder="Enter your message"
                  value={formValues.whatsapp_msg_french}
                  onChange={(e) =>
                    handleFormValues(e.target.value, "whatsapp_fr")
                  }
                />
              </Box>
            </>
          );

        default:
          return null;
      }
    };

    return (
      <Box className="mainTabsSection">
        <Tabs
          value={activeLanguageTab}
          onChange={(e, newValue) => {
            console.log("selectedKey>>", newValue);
            setActiveLanguageTab(newValue);
          }}
          variant="fullWidth"
        >
          <Tab label="EN" value="home" />
          <Tab label="ES" value="link-1" />
          <Tab label="FR" value="link-2" />
        </Tabs>
        <Box mt={2}>{renderContent()}</Box>
      </Box>
    );
  };

  const handleMarkerDragEnd = (e) => {
    const newPos = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    console.log("New position:", newPos);
    setMapCenter(newPos);
  };

  const handlePlaceSelected = useCallback(
    debounce((place) => {
      if (!place || !place.geometry) return;

      const location = place.geometry.location;
      const lat = location.lat();
      const lng = location.lng();
      console.log("Selected place:", place.formatted_address);
      handleFormValues(place.formatted_address, "address");
      console.log("Selected place: Lat:", lat, "Lng:", lng);
      setMapCenter({
        lat: lat,
        lng: lng,
      });
      setZoom(16);
    }, 2000),
    [] // only create debounced function once
  );

  const renderQuestion = (element, idx) => (
    <div className="quesDiv" key={idx}>
      {getQuestionType(element)}
    </div>
  );

  const generateQr = async (param) => {
    if (param == 'new') {
      formRef.current.reset()
    } else {
      // const form = param.currentTarget;
      // param.preventDefault();
      // param.stopPropagation();

      // if (form.checkValidity() === false || formValues.partner_type == '' || countryCode == '' || formValues.address == '') {
      //   setValidated(true);
      // } else {
      //   setValidated(false);
      //   const { partner_name, partner_phone_no, email } = formValues;
      //   // Check if all required fields are filled and valid
      //   if (!partner_name || !/^[a-zA-Z\s]*$/.test(partner_name)) {
      //     swal({
      //       title: 'Enter valid name'
      //     })
      //     return false;
      //   }
  
      //   if (!partner_phone_no || !/^\d{10}$/.test(partner_phone_no)) {
      //     swal({
      //       title: 'Enter valid phone number'
      //     })
      //     return false;
      //   }
  
      //   if (!email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      //     swal({
      //       title: 'Enter valid email'
      //     })
      //     return false;
      //   }
      //   formValues.gps_lat = mapCenter.lat
      //   formValues.gps_lng = mapCenter.lng      
      //   if(
      //     formValues.partner_name == '' ||
      //     formValues.partner_phone_no == '' ||
      //     formValues.partner_type == '' ||
      //     formValues.email == '' ||
      //     formValues.address == '' ||
      //     formValues.gps_lat == '' ||
      //     formValues.gps_lng == '' ||
      //     formValues.message_top_english == '' ||
      //     formValues.message_bottom_english == '' ||
      //     formValues.message_top_spanish == '' ||
      //     formValues.message_bottom_spanish == '' ||
      //     formValues.message_top_french == '' ||
      //     formValues.message_bottom_french == '' ||
      //     countryCode == ''
      //   ){
      //     swal({
      //       title: 'Please fill all details',
      //       icon: 'warning'
      //     })
      //   } else {
      //     getRefCode()
      //   }   
      // }
      getRefCode()
    }
  };

  const getRefCode = () => {
    try{
      setIsLoading(true)
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      
      let params = {
        partner_name: formValues.partner_name,
        partner_phone_no: countryCode + formValues.partner_phone_no,
        partner_type: formValues.partner_type,
        email: formValues.email,
        address: formValues.address,
        gps_lat: mapCenter.lat,
        gps_lng: mapCenter.lng,
        message_top_english: formValues.message_top_english,
        message_bottom_english: formValues.message_bottom_english,
        message_top_spanish: formValues.message_top_spanish,
        message_bottom_spanish: formValues.message_bottom_spanish,
        message_top_french: formValues.message_top_french,
        message_bottom_french: formValues.message_bottom_french,
      };
      
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(params),
        redirect: 'follow'
      };

      fetch('https://aloxa.ai/flaskservice/add_partner', requestOptions)
        .then((res) => res.json())
        .then((result) => {
          console.log("getRefCode resulttt", result); 
          if(result){
            setRefCode(result.code)
            setGenerateQRCode(true)
            setGenerateDummyQR(true)
          }
        })
        .catch((err) => {
          console.log("err", err);   
        })
    } catch (err){
      console.log('err', err)
    }
  }

  const sendQRCode = async (urlENG, urlESP, urlFR) => {
    let qrEng
    let qrEsp
    let qrFr
    try{
      qrEng = await compressBase64Image(QREng)
      qrEsp = await compressBase64Image(QREsp)
      qrFr = await compressBase64Image(QRFr)
      if(qrEng && qrEsp && qrFr){
        setQRLinkEng(urlENG)
        setQRLinkEsp(urlESP)
        setQRLinkFr(urlFR)
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        let params = ({
          qr_english: qrEng,
          qr_spanish: qrEsp,
          qr_french: qrFr,
          url_english: urlENG,
          url_spanish: urlESP,
          url_french: urlFR,
          partner_code: refCode
        });
        if(generateDummyQR){
          // document.getElementById('aloxamainpage').style.overflowY = 'hidden'
          setIsLoading(false)
          console.log("parammsss final", params);
          setGenerateDummyQR(false)
          // document.getElementById('aloxamainpage').style.overflowY = 'auto'
          let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(params),
            redirect: 'follow'
          };
          fetch('https://aloxa.ai/flaskservice/add_partner_qrcode', requestOptions)
            .then((res) => res.json())
            .then((result) => {
              console.log("sendQRCode resulttt", result); 
            })
            .catch((err) => {
              console.log("err", err);   
            })
        }
      }
    } catch(err) {
      console.log('err', err)
    }
  }

  const copyUrl = async () => {
    try{
      if(activeLanguageTab == 'home'){
        await navigator.clipboard.writeText(QRLinkEng)
      } else if(activeLanguageTab == 'link-1'){
        await navigator.clipboard.writeText(QRLinkEsp)
      } else if(activeLanguageTab == 'link-2'){
        await navigator.clipboard.writeText(QRLinkFr)
      } 
      setCopySuccess('Copied!')
      setTimeout(() => {
        setCopySuccess('')
      }, 2000)
    } catch (err){
      console.log('err', err)
    }
  }

  const renderQr = (activeLink) => {
    let urlEng
    let urlEsp
    let urlFr
    try{
      urlEng = `https://tinyurl.com/Hair-AI-Test`
      urlEsp = `https://tinyurl.com/Hair-AI-Test-Es`
      urlFr = `https://tinyurl.com/Hair-AI-Test-Fr`
      return (
        <>
          <div className={generateQRCode ? "showQrDiv" : "noShowQrDiv"}>
            {activeLink == "home" ? (
              <div className="engQr">
                <div ref={qrEngRef} className="generateQRPdfMainSection">
                  <div className="generateQRPdfSection">
                    <div className="generatePdfDiv">
                      <div>
                        <img src={imgurl.hairlossaiLogo} className="aloxaLogo"></img>
                        <h5>{formValues.message_top_english}</h5>
                      </div>
                      <div className="qrCodeImg">
                        {generateQRCode ? (
                          <QRCodeSVG
                            value={urlEng}
                            title={"English QR Code"}
                            size={300}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"L"}
                          />
                        ) : (
                          <img src={imgurl.defaultQr} alt="default qr" />
                        )}
                      </div>
                      <div className="pdfText">
                        <p>{formValues.message_bottom_english}</p>
                        <img src={imgurl.whatsAppIcon}></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : activeLink == "link-1" ? (
              <div className="engQr">
                <div ref={qrEspRef} className="generateQRPdfMainSection">
                  <div className="generateQRPdfSection">
                    <div className="generatePdfDiv">
                      <div>
                        <img src={imgurl.hairlossaiLogo} className="aloxaLogo"></img>
                        <h5>{formValues.message_top_spanish}</h5>
                      </div>
                      <div className="qrCodeImg">
                        {generateQRCode ? (
                          <QRCodeSVG
                            value={urlEsp}
                            title={"English QR Code"}
                            size={300}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"L"}
                          />
                        ) : (
                          <img src={imgurl.defaultQr} alt="default qr" />
                        )}
                      </div>
                      <div className="pdfText">
                        <p>{formValues.message_bottom_spanish}</p>
                        <img src={imgurl.whatsAppIcon}></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : activeLink == "link-2" ? (
              <div className="engQr">
                <div ref={qrFrRef} className="generateQRPdfMainSection">
                  <div className="generateQRPdfSection">
                    <div className="generatePdfDiv">
                      <div>
                        <img src={imgurl.hairlossaiLogo} className="aloxaLogo"></img>
                        <h5>{formValues.message_top_french}</h5>
                      </div>
                      <div className="qrCodeImg">
                        {generateQRCode ? (
                          <QRCodeSVG
                            value={urlFr}
                            title={"English QR Code"}
                            size={300}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"L"}
                          />
                        ) : (
                          <img src={imgurl.defaultQr} alt="default qr" />
                        )}
                      </div>
                      <div className="pdfText">
                        <p>{formValues.message_bottom_french}</p>
                        <img src={imgurl.whatsAppIcon}></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      );
    } catch (err){
      console.log("err", err);   
    } finally{
      sendQRCode(urlEng, urlEsp, urlFr)
    }
    
  };

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='generateqrpage photo-container main-section-container'>
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center header"
        >
          <Grid item xs={1} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span
                className="backButtonDiv"
                onClick={() => navigate(-1)}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={10}
            className="d-flex justify-content-center align-items-center reportPageHead"
          >
            <Typography variant="h6" className="title ml-0px">
              {i18next.t("Generate QR")}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Sidebar />
          </Grid>
        </Grid>
        <div className='mainGenerateQr'>
        <div className='formContainer mt-20px'>
          {
            formQuestions.map((ele) => {
              return(
                renderQuestion(ele)
              )
            })
          }
          <Button onClick={() => generateQr()} className='commonButton'>Submit</Button>
        </div>
        {renderQr(activeLanguageTab)}
        {generateDummyQR && (
          <Box id="dummyQR" className="dummyQR">
            <Grid container spacing={2}>
              {/* English QR */}
              <Grid item lg={12}>
                <Box className="engQr">
                  <Box ref={qrEngRef} className="generateQRPdfMainSection">
                    <Box className="generateQRPdfSection">
                      <Box className="generatePdfDiv">
                        <Box>
                          <img src={imgurl.hairlossaiLogo} className="aloxaLogo" alt="Aloxa Logo" />
                          <Typography variant="h5">{formValues.message_top_english}</Typography>
                        </Box>
                        <Box className="qrCodeImg">
                          {generateQRCode ? (
                            <QRCodeCanvas
                              value={`https://tinyurl.com/Hair-AI-Test`}
                              title={"English QR Code"}
                              size={300}
                              bgColor={"#ffffff"}
                              fgColor={"#000000"}
                              level={"L"}
                            />
                          ) : (
                            <img src={imgurl.defaultQr} alt="default qr" />
                          )}
                        </Box>
                        <Box className="pdfText">
                          <Typography variant="body1">{formValues.message_bottom_english}</Typography>
                          <img src={imgurl.whatsAppIcon} alt="WhatsApp Icon" />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* Spanish QR */}
              <Grid item lg={12}>
                <Box className="engQr">
                  <Box ref={qrEspRef} className="generateQRPdfMainSection">
                    <Box className="generateQRPdfSection">
                      <Box className="generatePdfDiv">
                        <Box>
                          <img src={imgurl.hairlossaiLogo} className="aloxaLogo" alt="Aloxa Logo" />
                          <Typography variant="h5">{formValues.message_top_spanish}</Typography>
                        </Box>
                        <Box className="qrCodeImg">
                          {generateQRCode ? (
                            <QRCodeCanvas
                              value={`https://tinyurl.com/Hair-AI-Test-Es`}
                              title={"Spanish QR Code"}
                              size={300}
                              bgColor={"#ffffff"}
                              fgColor={"#000000"}
                              level={"L"}
                            />
                          ) : (
                            <img src={imgurl.defaultQr} alt="default qr" />
                          )}
                        </Box>
                        <Box className="pdfText">
                          <Typography variant="body1">{formValues.message_bottom_spanish}</Typography>
                          <img src={imgurl.whatsAppIcon} alt="WhatsApp Icon" />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* French QR */}
              <Grid item lg={12}>
                <Box className="engQr">
                  <Box ref={qrFrRef} className="generateQRPdfMainSection">
                    <Box className="generateQRPdfSection">
                      <Box className="generatePdfDiv">
                        <Box>
                          <img src={imgurl.hairlossaiLogo} className="aloxaLogo" alt="Aloxa Logo" />
                          <Typography variant="h5">{formValues.message_top_french}</Typography>
                        </Box>
                        <Box className="qrCodeImg">
                          {generateQRCode ? (
                            <QRCodeCanvas
                              value={`https://tinyurl.com/Hair-AI-Test-Fr`}
                              title={"French QR Code"}
                              size={300}
                              bgColor={"#ffffff"}
                              fgColor={"#000000"}
                              level={"L"}
                            />
                          ) : (
                            <img src={imgurl.defaultQr} alt="default qr" />
                          )}
                        </Box>
                        <Box className="pdfText">
                          <Typography variant="body1">{formValues.message_bottom_french}</Typography>
                          <img src={imgurl.whatsAppIcon} alt="WhatsApp Icon" />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
        </div>

      </div>
    </>
  )
}

export default GenerateQr